import { __decorate, __metadata } from "tslib";
import { Type } from 'class-transformer';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'lodash';
import { EngagementActivity } from './engagementActivity';
let EngagementStageModel = /** @class */ (() => {
    class EngagementStageModel {
        constructor() {
            this.stageId = uuidv4();
            this.stageName = '';
            this.isTenantVisible = true;
            this.description = '';
            this.displayOrder = null;
            this.activities = [];
        }
    }
    __decorate([
        Type(() => EngagementActivity),
        __metadata("design:type", Array)
    ], EngagementStageModel.prototype, "activities", void 0);
    return EngagementStageModel;
})();
export { EngagementStageModel };
export default class EngagementStage extends EngagementStageModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
    get activityCount() {
        return this.activities.length;
    }
    get hourCount() {
        return 0;
    }
    get docsCount() {
        return _.sumBy(this.activities, function (o) {
            return o.docs.length;
        });
    }
    get allActivitiesComplete() {
        if (this.activities.length > 0) {
            if (this.activities.every(x => x.isDone === true)) {
                return true;
            }
            return false;
        }
        return false;
    }
}
